<script>
  import { onMount } from "svelte";
  import {M} from "../external";

  export let domain;
  let input, email = '';

  export function get() {
    return email;
  }

  onMount(() => {
    input.focus();
  });
</script>

<div class="popup-input-wrapper ">
  <div class="col20 f-left help-text mt-25">{M.EMAL_DOMAIN_VERIFICATION_PROMPT}</div>
  <div class="col20 f-left flex justify-center align-center">
    <input bind:this={input} type="text" bind:value={email} placeholder={M.EMAIL} class="half-input" />
    <span class="flex-none">{"@" + domain}</span>
  </div>
</div>

<style>
  input {
    border-left: 0px none;
    border-top: 0px none;
    border-right: 0px none;
    text-align: right;
    padding-right: 20px !important;
  }
</style>
